module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA+BAMAAACmQTSfAAAAJFBMVEUAAABGABNGABNGABNGABNGABNGABNGABNGABNGABNGABNGABNq5DfOAAAADHRSTlMAS1BWPiYdNRoMQySJ7uVrAAAApUlEQVQ4y2NgYGB1VEIFIhsYgIBDWEkQFQhbNQDFkwxhfISEGgMDJ0I1AihNYGA3FBQyRgWKgsIODI2KgiqhqMBJUEiCoUhQqIABFbArCqozOAsqTkAT5xQSNAGJM6CDUfFR8VFxeomzuSRgFU8yVsMmDmSZ4BC3IskcDpcE6vsLVzmDq1wClWMm2MoxFqzlXgGuchJnucrAsRhdQglcDjNwYyu3AXf1VaTHbyIWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/phone-icon.png
// module id = ygyv
// module chunks = 1